import React from 'react';
import logo from '../assets/akenvivo_logo.png';

const Header = () => (
    <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: 'black'
    }}>
        <img src={logo} alt="AKenvivo Logo" style={{ maxWidth: '30%' }} />
    </div>
);

export default Header;
